export class PortProtocolService {
  portProtocolServiceId?: number;
  clientITProfileId?: number;
  ports?: string;
  protocols?: string;
  service?: string;
  purpose?: string;
  reference?: string;
  usedBy?: string;
}
